import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SurveysSub() {
  const location = useLocation();
  const isActive = (NavLink) => location.pathname.includes(NavLink);
  const { t } = useTranslation();

  return (
    <div>
      <ul className="flex justify-center items-center md:text-base text-sm gap-2 md:gap-[3rem] mt-6 font-poppins">
        <li
          className={`flex justify-center items-center px-4 py-3 text-sky-700 rounded-full border border-sky-700 border-opacity-60 cursor-pointer ${isActive("/my-surveys")
            ? "bg-cyan-600 bg-opacity-25"
            : "hover:bg-sky-700 hover:bg-opacity-5"
            }`}
        >
          <NavLink to="/my-surveys" className="text-center">{t("side.bar.Best")}</NavLink>
        </li>
        <li
          className={`flex justify-center items-center px-4 py-3 text-sky-700 rounded-full border border-sky-700 border-opacity-60 cursor-pointer ${isActive("/short-survey")
            ? "bg-cyan-600 bg-opacity-25"
            : "hover:bg-sky-700 hover:bg-opacity-5"
            }`}
        >
          <NavLink to="/short-survey" className="text-center">{t("side.bar.Short")}</NavLink>
        </li>
        <li
          className={`flex justify-center items-center px-4 py-3 text-sky-700 rounded-full border border-sky-700 border-opacity-60 cursor-pointer ${isActive("/most-point")
            ? "bg-cyan-600 bg-opacity-25"
            : "hover:bg-sky-700 hover:bg-opacity-5"
            }`}
        >
          <NavLink to="/most-point" className="text-center">{t("side.bar.Most")}</NavLink>
        </li>
      </ul>
    </div>
  );
}

export default SurveysSub;
